export default __webpack_public_path__ + "_/images/app/apk/apk-6-bdeceeb4ca61ab9a5cdf218420607c6ca2146791e7043ac721971bd081fbaa90.png";